import { render, staticRenderFns } from "./AttachmentsBlock1.vue?vue&type=template&id=0fd2b4c0"
import script from "./AttachmentsBlock1.vue?vue&type=script&lang=js"
export * from "./AttachmentsBlock1.vue?vue&type=script&lang=js"
import style0 from "../attachments-shared.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports